import {environment} from "environments";
class SLVToggleController {
  /* @ngInject */
  constructor($log, Endpoints, Business, SLVToggle, Auth, toastr) {
    Object.assign(this, {
      $log,
      Endpoints,
      Business,
      SLVToggle,
      Auth,
      toastr,
      services: [],
    });
    this.getAllServices();
  }


  getAllServices() {
    this.SLVToggle.getAllServices()
      .then(({ data }) => {
        return this.SLVToggle.getAiDermConfig()
          .then((configRes) => {
            const configMap = {};
            configRes.data.categories.forEach(configItem => {
              configMap[configItem.id] = {
                enabled_brochure: configItem.enabled_brochure,
                enabled_pims: configItem.enabled_pims
              };
            });
            this.mapServices(data, configMap);
          })
          .catch((err) => {
            console.error("Failed to fetch AiDerm config:", err);
            this.mapServices(data, {});
          });
      });
  }
  mapServices(data, configMap) {
    data.categories.forEach((service) => {
      service.show_slv_required = !!service.slv_required;
      service.show_slv_optional = !!service.slv_optional;
      service.phone_call_required = !!service.phone_call_required;
      service.active_web = !!service.active_web;
      service.service_enabled = !!service.service_enabled;
      service.batching_enabled = !!service.batching_enabled;
      service.pick_up_available = service.pick_up_visible_to_patient !== null;
      service.mail_order_available = service.mail_order_visible_to_patient !== null;
      service.special_delivery_available = service.special_delivery_visible_to_patient !== null;
      service.signature_required_delivery_available = service.signature_required_delivery_visible_to_patient !== null;
      service.pick_up_visible_to_patient = !!service.pick_up_visible_to_patient;
      service.mail_order_visible_to_patient = !!service.mail_order_visible_to_patient;
      service.special_delivery_visible_to_patient = !!service.special_delivery_visible_to_patient;
      service.signature_required_delivery_visible_to_patient = !!service.signature_required_delivery_visible_to_patient;

      const aiConfig = configMap[service.category_id];
      service.ai_derm_enabled_pims = aiConfig?.enabled_pims ?? undefined;
      service.ai_derm_enabled_brochure = aiConfig?.enabled_brochure ?? undefined;
    });

    const mapped = data.categories.map((category, i) => ({
      index: i,
      category_name: category.category_name
    }));
    mapped.sort((a, b) => a.category_name.localeCompare(b.category_name));
    this.services = mapped.map(el => data.categories[el.index]);
  }

  toggle_ai_derm(service, source, newValue) {
    this.SLVToggle.toggleAiDerm(service.category_id, source, newValue)
      .then(() => {
        this.toastr.success(`Updated AiDerm ${source} toggle.`);
      })
      .catch((err) => {
        console.error('AiDerm toggle failed:', err);
        this.toastr.error(`Failed to update AiDerm ${source} toggle.`);
        this.getAllServices();
      });
  }


  toggle_slv_required(service, show_slv_required, show_slv_optional, phone_call_required) {

    this.SLVToggle.toggle(service, show_slv_required, show_slv_optional)
      .then(() => {
        this.toggle_phone_call_required(service, show_slv_required, phone_call_required);
      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.error && err.data.error.message) {
          this.toastr.error('Error: ' + err.data.error.message);
        } else if (err && err.data) {
          this.toastr.error('Error changing switch: ' + JSON.stringify(err.data));
        }
        this.getAllServices();
      });
  }

  toggle_slv_optional(service, show_slv_required, show_slv_optional) {

    this.SLVToggle.toggle(service, show_slv_required, show_slv_optional)
      .then(() => {

      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.error && err.data.error.message) {
          this.toastr.error('Error: ' + err.data.error.message);
        } else if (err && err.data) {
          this.toastr.error('Error changing switch: ' + JSON.stringify(err.data));
        }
        this.getAllServices();
      });
  }

  toggle_phone_call_required(service, show_slv_required, phone_call_required) {
    this.SLVToggle.toggle_phone_call_required(service, show_slv_required, phone_call_required)
      .then(() => {

      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.error && err.data.error.message) {
          this.toastr.error('Error: ' + err.data.error.message);
        } else if (err && err.data) {
          this.toastr.error('Error changing switch: ' + JSON.stringify(err.data));
        }
        this.getAllServices();
      });
  }

  toggleDelivery(category_id, pharmacy_option_id, is_visible) {
    this.SLVToggle.toggleDelivery(category_id, pharmacy_option_id, is_visible)
      .then(() => {

      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.error && err.data.error.message) {
          this.toastr.error('Error: ' + err.data.error.message);
        } else if (err && err.data) {
          this.toastr.error('Error changing switch: ' + JSON.stringify(err.data));
        }
        this.getAllServices();
      });
  }

  toggle_batching_enabled(service_id, batching_enabled) {
    this.SLVToggle.toggle_batching_enabled(service_id, batching_enabled)
      .then(() => {})
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.error && err.data.error.message) {
          this.toastr.error('Error: ' + err.data.error.message);
        } else if (err && err.data) {
          this.toastr.error('Error changing switch: ' + JSON.stringify(err.data));
        }
        this.getAllServices();
      });
  }
  toggle_service_enabled(service_id, service_enabled) {
    this.SLVToggle.toggle_service_enabled(service_id, service_enabled)
      .then(() => {})
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.error && err.data.error.message) {
          this.toastr.error('Error: ' + err.data.error.message);
        } else if (err && err.data) {
          this.toastr.error('Error changing switch: ' + JSON.stringify(err.data));
        }
        this.getAllServices();
      });
  }
}

SLVToggleController.$inject = ["$log", "Endpoints", "Business", "SLVToggle", "Auth", "toastr"];
angular.module('pims').controller('SLVToggleController', SLVToggleController);
